<template>
  <table aria-labelledby="table-heading-lg">
		<caption id="table-heading-lg">Accountability Letter Grade 2016 - 2017</caption>
		<thead>
			<tr>
				<th>{{ s1Name }}</th>
				<th>{{ s2Name }}</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td>{{ s1Data.isNull ? NA : `'${s1Data.grade}'` }}</td>
				<td>{{ s2Data.isNull ? NA : `'${s2Data.grade}'` }}</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
	export default {
		props: ['s1Name', 's2Name', 's1Data', 's2Data'],
		data() {
			return {
				NA: 'data point unavailable'
			}
		}
	}
</script>
